import { render, staticRenderFns } from "./ErpcDashCaseView.vue?vue&type=template&id=6caad976&scoped=true&"
import script from "./ErpcDashCaseView.vue?vue&type=script&lang=ts&"
export * from "./ErpcDashCaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caad976",
  null
  
)

export default component.exports